import { ButtonComponentConfig } from '../button';
import { MessageAuthorType } from './message-author-type.enum';

export interface IChatMessage {
  content: string;
  messageAuthorType: MessageAuthorType;
  additionalButton?: ButtonComponentConfig;
  date?: string;
  metadata?: any;
  role?: string;
}
